import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";

export default {
    component: loadingComponent,
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({
            title: lang === "hu" ? "Felhasználási feltételek" : "Terms of usage",
            allMessage,
            lang,
            type: "article",
        });
    },
};
